import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { SeedsService } from 'src/app/services/seeds.service';

@Component({
  selector: 'app-distribuidor',
  templateUrl: './distribuidor.component.html',
  styleUrls: ['./distribuidor.component.scss'],
})
export class DistribuidorComponent implements OnInit {
  public foto="../../../assets/img/distribuidor.jpg"
  public nombre
  public correo: any;
  public municipio: any;
  public ciudad: any;
  public puntosSemilla: number=0;
  public ruterosSemilla: number=0;
  public authen
  constructor(
    private auth:AuthService, 
    private authing:AngularFireAuth,
    private seeds:SeedsService,
    private router:NavController) { 
    this.sessionData()

    
  }

  ngOnInit() {
    this.authing.auth.onAuthStateChanged(f=>{
      this.authen=f.uid
      this.traerPuntosRuterosCreados()
      this.traerPuntosSemillaCreados()
  })
  }

  gotoSeeds(){
     this.router.navigateForward('/seeds')
  }

  gotoInventario(){
    this.router.navigateForward('/inventario')
 }
 /**
  * The function gotoRouters() is a function that navigates to the route /ruteros
  */
  gotoRouters(){
    this.router.navigateForward('/ruteros')

  }
  /**
   * A function that is responsible for obtaining the data of the user who is logged in.
   */
  sessionData(){
    this.authing.auth.onAuthStateChanged(k=>{
       this.auth.datosPefilSesion(k.uid).subscribe(o=>{
           this.foto=o.data()['foto']
           this.nombre=o.data()['nombre']
           this.correo=o.data()['email']
           this.ciudad=o.data()['ciudad']
           this.municipio=o.data()['municipio']
       })
  
    })
   }
 /**
  * It gets the number of seed points created by the provider.
  */
   traerPuntosSemillaCreados(){
    this.seeds.devolverPuntosSemillaProveedores(this.authen).subscribe(j=>{
        this.puntosSemilla=j.docs.length
    })
  }

/**
 * It returns the number of ruteros created by the user.
 */
  traerPuntosRuterosCreados(){
    this.seeds.devolverRuteros(this.authen).subscribe(j=>{
        this.ruterosSemilla=j.data()['rutero'].length
        
    })
  }
}
